import React, { useMemo } from 'react';
import { useStudio } from '../../Context/StudioContext';
import CardOpeningWrapper from '../Preview/CardOpeningWrapper';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CardParticles from '../CardView/CardParticles';

import DesignContent from "..//..//Components//Designs//DesignContent";
import DesignContentPage3 from "..//..//Components//Designs//DesignContentPage3";
import DesignContentPage4 from '../Designs/DesignContentPage4';
import DesignContentPage5 from '../Designs/DesignContentPage5';
import DesignContentPage6 from '../Designs/DesignContentPage6';
import DesignContentPage7 from '../Designs/DesignContentPage7';

const PreviewCard = ({ currentPage }) => {
  const { formData } = useStudio();

  const themeColour = formData.themeColour || '#68D2D2';
  const themeBaseCardColour = formData.themeBaseCardColour || '#ffffff';
  const isClassicTemplate = formData.designTemplate === "classic";

  const theme = useMemo(() => createTheme({
    typography: {
      fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: themeColour,
              },
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: themeColour,
            },
          },
        },
      },
    },
  }), [themeColour]);

  const renderContent = () => {
    switch (currentPage) {
      case 1:
      case 2:
        return <DesignContent data={formData} />;
      case 3:
      case 4:
        return <DesignContentPage3 data={formData} />;
      case 5:
        return <DesignContentPage5 data={formData} />;
      case 6:
        return <DesignContentPage6 data={formData} />;
      case 7:
        return <DesignContentPage7 data={formData} />;
      default:
        return <div>No preview</div>;
    }
  };

  const backgroundStyle = isClassicTemplate
    ? {
      backgroundImage: `linear-gradient(rgba(226, 128, 47, 0.38)), url(/card-backgrounds/klasikFullBackground.jpg)`,
      backgroundSize: "100% 100%",
    }
    : {
      backgroundColor: themeBaseCardColour,
    };

  return (
    <ThemeProvider theme={theme}>
      <CardOpeningWrapper data={formData} openingStyle={formData.openingStyle} openingColor={formData.openingColor}>
        <div className="scroll-hide" style={{ position: 'relative', alignContent: 'center', height: '550px', width: '100%', ...backgroundStyle }}>
          {renderContent()}
        </div>
      </CardOpeningWrapper>
    </ThemeProvider>
  );

};

export default PreviewCard;
